// extracted by mini-css-extract-plugin
module.exports = {"field":"_0fce717cdb--field--19-or","label":"_0fce717cdb--label--2U_DQ","stack":"_0fce717cdb--stack--1c4JR"};